export const BRANDS = [
  { id: "brand_1", label: "BrandAlpha" },
  { id: "brand_2", label: "BrandBeta" },
  { id: "brand_3", label: "BrandGamma" },
  { id: "brand_4", label: "BrandDelta" },
];

export const SKU_BY_BRAND = {
  brand_1: [
    { id: "sku_1_1", label: "Alpha 200g", basePrice: 24.99 },
    { id: "sku_1_2", label: "Alpha 500g", basePrice: 54.99 },
    { id: "sku_1_3", label: "Alpha 1kg",  basePrice: 99.99 },
  ],
  brand_2: [
    { id: "sku_2_1", label: "Beta Classic", basePrice: 32.50 },
    { id: "sku_2_2", label: "Beta Pro",     basePrice: 48.75 },
  ],
  brand_3: [
    { id: "sku_3_1", label: "Gamma Lite",  basePrice: 19.99 },
    { id: "sku_3_2", label: "Gamma Max",   basePrice: 39.99 },
    { id: "sku_3_3", label: "Gamma Plus",  basePrice: 59.99 },
  ],
  brand_4: [
    { id: "sku_4_1", label: "Delta Standard", basePrice: 27.00 },
    { id: "sku_4_2", label: "Delta Premium",  basePrice: 52.00 },
  ],
};

export const WEEKS = Array.from({ length: 52 }, (_, i) => ({
  id: `w${i + 1}`,
  label: `W${String(i + 1).padStart(2, "0")} 2024`,
  weekNum: i + 1,
}));

export const MOCK_PLANNER_EVENTS = [
  {
    id: "evt_1",
    scenarioName: "Q1 Summer Blast",
    brand: "BrandAlpha",
    weekStart: 1,
    weekEnd: 4,
    discountPct: 15,
    color: "#00265E",
  },
  {
    id: "evt_2",
    scenarioName: "Feb Deep Discount",
    brand: "BrandBeta",
    weekStart: 5,
    weekEnd: 8,
    discountPct: 25,
    color: "#d10000",
  },
  {
    id: "evt_3",
    scenarioName: "Spring Value Pack",
    brand: "BrandGamma",
    weekStart: 10,
    weekEnd: 14,
    discountPct: 10,
    color: "#2e7d32",
  },
  {
    id: "evt_4",
    scenarioName: "Mid-Year Push",
    brand: "BrandDelta",
    weekStart: 26,
    weekEnd: 30,
    discountPct: 12,
    color: "#5750FF",
  },
];

export const MOCK_OPTIMIZER_RESULTS = {
  generatedAt: "2024-02-10T08:00:00Z",
  totalBudget: 500000,
  allocatedBudget: 487000,
  expectedROI: 2.1,
  actualVolumeLiters: 26800,
  actualContributionMargin: 145000,
  warnings: [
    "Budget binds in weeks W34–W38 — optimizer could not fully fund all uplift targets.",
    "Beta Pro at 18% discount sits above preferred cannibalisation guardrail until weeks tighten.",
  ],
  mustPromoteWeeks: [
    {
      id: "mp_1",
      weeksLabel: "W40 – W42",
      scope: "Portfolio",
      detail: "Corporate mandate — promotions required in this window.",
    },
    {
      id: "mp_2",
      weeksLabel: "W08",
      scope: "Beta Classic",
      detail: "Contractual retailer obligation for this SKU.",
    },
  ],
  recommendedPlanSummary:
    "Shift Alpha earlier with a softer discount, hold Gamma tight on depth, and reserve capacity for mandatory late-year windows while keeping portfolio ROI above target.",
  recommendations: [
    {
      id: "rec_1",
      brand: "BrandAlpha",
      sku: "Alpha 200g",
      recommendedWeeks: "W01 – W04",
      recommendedDiscount: 12,
      userWeeks: "W02 – W05",
      userDiscount: 15,
      expectedUplift: 13.5,
      expectedROI: 2.3,
      priority: "High",
      touchesMandatoryWindow: false,
    },
    {
      id: "rec_2",
      brand: "BrandGamma",
      sku: "Gamma Max",
      recommendedWeeks: "W10 – W13",
      recommendedDiscount: 8,
      userWeeks: "W10 – W13",
      userDiscount: 12,
      expectedUplift: 9.0,
      expectedROI: 2.6,
      priority: "High",
      touchesMandatoryWindow: false,
    },
    {
      id: "rec_3",
      brand: "BrandBeta",
      sku: "Beta Pro",
      recommendedWeeks: "W20 – W22",
      recommendedDiscount: 18,
      userWeeks: "W18 – W24",
      userDiscount: 22,
      expectedUplift: 20.0,
      expectedROI: 1.5,
      priority: "Medium",
      touchesMandatoryWindow: true,
    },
    {
      id: "rec_4",
      brand: "BrandDelta",
      sku: "Delta Standard",
      recommendedWeeks: "W30 – W32",
      recommendedDiscount: 5,
      userWeeks: "W30 – W32",
      userDiscount: 5,
      expectedUplift: 5.5,
      expectedROI: 3.1,
      priority: "Low",
      touchesMandatoryWindow: false,
    },
  ],
};
